/**
 * Created by intellicar-rinas on 10/8/17.
 */
import _ from 'lodash';
import moment from 'moment';
import ReportAPIs from '../APIs/ReportAPIs';

export const get = (key) => {
    let data = localStorage.getItem(key);
    try{
        data = JSON.parse(data);
    } catch (e) {
        // Parsing Failed
    }
    return data;
};

export const save = (key, data = "") => {
    try{
        data = JSON.stringify(data);
    } catch (e) {
        // Stringify Failed
    }
    localStorage.setItem(key, data);
};

export const getGroupChildren = (parentPaths, includeParent, groupMap) => {

    let tMap = [];
    let arr = [];

    for(let jdx in parentPaths){
        for(let path in groupMap){
            if(path.indexOf(parentPaths[jdx]) === 0){
                if(path !== parentPaths[jdx] || includeParent){
                    tMap[path] = groupMap[path]
                }
            }
        }
    }

    for(let idx in tMap){
        arr.push(tMap[idx]);
    }

    return _.cloneDeep(arr);
};

export const processPermissions = (permissions, includeParent, groupMap) => {
    for(let idx in permissions){
        permissions[idx].groups = getGroupChildren(permissions[idx].grouppaths, includeParent, groupMap);
    }
    return permissions;
};

export const getPolygonCentroid = (pts) => {
    let first = pts[0], last = pts[pts.length-1];
    if (first.x !== last.x || first.y !== last.y) pts.push(first);
    let twicearea=0,
        x=0, y=0,
        nPts = pts.length,
        p1, p2, f;
    for ( let i=0, j=nPts-1 ; i<nPts ; j=i++ ) {
        p1 = pts[i]; p2 = pts[j];
        f = p1.x*p2.y - p2.x*p1.y;
        twicearea += f;
        x += ( p1.x + p2.x ) * f;
        y += ( p1.y + p2.y ) * f;
    }
    f = twicearea * 3;
    return { x:x/f, y:y/f };
}

export const getPolygonCenter = (latLngs) => {
    let center = getPolygonCentroid(latLngs.map(latLng=>{
        return {x:latLng.lat(), y:latLng.lng()}
    }));
    return new window.google.maps.LatLng(center.x, center.y);
};

export const JSONToCSVConvertor = (JSONData, ReportTitle, ShowLabel, showHeading=true,paramHeading = false) => {
    //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    let arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

    let CSV = '';

    //This condition will generate the Label/Header
    if (ShowLabel) {
        //Set Report title in first row or line

        // CSV += ReportTitle + '\r\n\n';
        //append Label row with line break
    }
    let row = "";
    //This loop will extract the label from 1st index of on array
    if(showHeading) {
        for (let index in arrData[0]) {
            if(!paramHeading)index = index.replace('_', ' ');
            //Now convert each value to string and comma-seprated
            row += index + ',';
        }
        row = row.slice(0, -1);
        CSV += row + '\r\n';
    }

    //1st loop is to extract each row
    for (let i = 0; i < arrData.length; i++) {
        let row = "";

        //2nd loop will extract each column and convert it in string comma-seprated
        for (let index in arrData[i]) {
            row += '"' + arrData[i][index] + '",';
        }

        row.slice(0, row.length - 1);

        //add a line break after each row
        CSV += row + '\r\n';
    }

    if (CSV == '') {
        alert("Invalid data");
        return;
    }

    //Generate a file name
    let fileName = "";
    //this will remove the blank-spaces from the title and replace it with an underscore
    ReportTitle = ReportTitle.trim()
    fileName = ReportTitle.replace(/ /g, "_");

    //Initialize file format you want csv or xls
    // let uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

    // Now the little tricky part.
    // you can use either>> window.open(uri);
    // but this will not work in some browsers
    // or you will not get the correct file extension

    //this trick will generate a temp <a /> tag
    let link = document.createElement("a");
    // link.href = uri;

    let csvData = new Blob([CSV], {type: 'text/csv'});
    let csvUrl = URL.createObjectURL(csvData);
    link.href = csvUrl;

    //set the visibility hidden so it will not effect on your web-layout
    link.style.cssText += ";visibility:hidden";
    link.download = fileName + ".csv";

    //this part will append the anchor tag and remove it after automatic click
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

const getVehiclesFromGroup=(group)=>{
    let vehicles = [];
    if(group) {
        if(group.vehicles && group.checked) {
            vehicles = [...group.vehicles.map(v=>{
                return v.id || v.userid || v.vehicleid
            })]
        }
        if(group.users && group.checked) {
            vehicles = [...vehicles, ...group.users.map(v=>{
                return v.id || v.userid || v.vehicleid
            })]
        }
        if(group.children) {
            for(let idx in group.children) {
                if(group.children[idx].groupid != null) {
                    vehicles = [...vehicles, ...getVehiclesFromGroup(group.children[idx])];
                }
            }
        }
    }
    return vehicles;
};

export const calculateAllowedVehicles =data=> {
    return getVehiclesFromGroup(data);
};


/*
*
* */


export const reqTracker = function(params) {
    let firedAt = Date.now();
    params.api(params.body)
        .then(r=>params.callback(r, 1, params, firedAt), r=>params.callback(r, 0, params, firedAt))
};


export const bulkReqTracker = function(apiListRaw, callback=()=>{}, onProgress=()=>{}, key) {

    const apiList = [...apiListRaw];

    function _onProgress(resp, status, params, firedAt) {
        respondedAPIs.push({resp, status, params, firedAt});
        let startedAt = Date.now();
        onProgress({
            respondedAPIs: [...respondedAPIs],
            failedAPIs: [...respondedAPIs.filter(i=> i.status === 0)],
            succeededAPIs: [...respondedAPIs.filter(i=> i.status === 1)],
            totalAPIsCount: apiList.length,
            respondedAPIsCount: respondedAPIs.length,
            progress: respondedAPIs.length / apiList.length * 100,
            successProgress: respondedAPIs.filter(i=> i.status === 1).length / apiList.length * 100,
            failureProgress: respondedAPIs.filter(i=> i.status === 0).length / apiList.length * 100,
            key
        });
        if(respondedAPIs.length === apiList.length) {
            let response = [...respondedAPIs].sort((a, b)=> a.firedAt-b.firedAt);
            let finishedAt = Date.now();
            callback(response, {
                key,
                startedAt,
                finishedAt,
                duration: finishedAt - startedAt,
                failedAPIs: [...respondedAPIs.filter(i=> i.status === 0)],
                succeededAPIs: [...respondedAPIs.filter(i=> i.status === 1)],
            });
        }
    }

    let respondedAPIs = [];
    let counter = 0;

    let trackerInterval = setInterval(()=> {
        if(apiList[counter]) {
            apiList[counter].callback = _onProgress;
            reqTracker(apiList[counter]);
            counter++;
        } else {
            clearInterval(trackerInterval);
        }
    });

};

export const indianNumberFormat = (x) => {
    var afterPoint = '';
    if(x.indexOf('.') > 0)
    afterPoint = x.substring(x.indexOf('.'),x.length);
    x = Math.floor(x);
    x=x.toString();
    var lastThree = x.substring(x.length-3);
    var otherNumbers = x.substring(0,x.length-3);
    if(otherNumbers != '')
        lastThree = ',' + lastThree;
    var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
    return res;
}

/**
 * Get last 2 tokens of address
 * Address, Address, HSR Layout, Bangalore (12.423459, 11.238393) -> HSR Layout, Bangalore
 */
export const stripLoc = (loc) => {
    let idx1 = loc.indexOf('(');
    let locc = idx1 > -1 ? loc.substring(0, idx1) : loc;
    let tokens = locc.split(',').map(f => f.trim());
    return tokens.slice(tokens.length - 3).join(', ');
}
export const isBlueSmart = (props) => {
    if (props.groupTree && props.groupTree.children) {
      const gTree = []
      const groups = props.groupTree.children;
      const gPath = [];
      for (let i in groups) {
        if (groups[i].path) {
          gTree.push(groups[i].path)
          gPath.push(gTree[i].split('/').filter(f => f).map(f => parseInt(f, 10)));
        }
      }
      // path selection
      for (let idx in gPath) {
        let groupPath = gPath[idx];
         for (let ndx in groupPath) {
          if(groupPath[ndx] === 3230) {
            return true
          }
         }
      }
    }
   }
export const getCanDataLiveReport = (schema) => {
    if (window.setReportWindowTabBusy) window.setReportWindowTabBusy(schema, true);
    if(schema && schema.content && schema.content[0].ref && schema.content[0].ref.refs && schema.content[0].ref.refs.table) {
        schema.content[0].ref.refs.table.setBusy(true)
    }
    let meta = [
        { "battery_voltage": 'V' },
        { "current": 'A' },
        { "soc": '%' },
        { "controller_temperature": '°C' }, 
        { "motor_temperature": '°C' },
        { "speed":'Kmph'},
        { "battery_current":'A'},
        { "odometer": 'km' },
        { "soh":'%'},
        { "battery_temperature":'°C'},
        { "engine_speed": 'rpm'},
        { "vehicle_speed":'kmph'}
    ]
    window.downloadCanData = []
    window.renderCanTable = true
    const auth = window.getAuth();
    let vehicleno = []
    if(window.snaplive === true){
        vehicleno.push(window.canDataVehicle)
    }      

    let body = {
        "token": auth.token,
        "vehicleno": vehicleno
    }

    const handleFailure  = () =>{
        window.canData = []
        window.downloadCanData = []
        // window.setReportWindowTabBusy(this.schema, false);
    }
    ReportAPIs.getLatestCanData(body).then((resp) => {
        handleSuccess(resp);
    }, handleFailure)

    const handleSuccess = (resp) => {
        window.canData = []
        window.downloadCanData = []
        for(let idx in resp){
            let keys = Object.keys(resp[idx])
            keys.map((key,index)=>{
                let obj = {}
                let dData = {}
                obj.slno = index+1
                obj.vehicleno = idx
                obj.parameter = key
                dData.slno = index+1
                dData.vehicleno = idx
                dData.parameter = key
                let unit = ''
                meta.map((data, index) => {
                    if (Object.keys(data)[0] == key) {
                        unit = Object.values(data)[0]
                    }
                })
                if (unit){
                    obj.value = resp[idx][key].value+' '+unit
                    dData.value = resp[idx][key].value
                    dData.unit = unit
                }else{
                    obj.value = resp[idx][key].value  
                    dData.value = resp[idx][key].value
                    dData.unit = ''
                }

                obj.time = moment(resp[idx][key].timestamp).format('DD-MMM  HH:mm:ss')
                dData.time = moment(resp[idx][key].timestamp).format('DD-MMM  HH:mm:ss')
                if(obj.uid){
                    delete obj.uid 
                }
                window.canData.push(obj)
                window.downloadCanData.push(dData)

            })
        }
    }
}